import React, { useState, useMemo } from "react";

// エリア一覧
const AREAS = [
  "メディテレーニアンハーバー",
  "アメリカンウォーターフロント",
  "ポートディスカバリー",
  "ロストリバーデルタ",
  "アラビアンコースト",
  "マーメイドラグーン",
  "ミステリアスアイランド",
  "ファンタジースプリングス",
  "パークワイド",
  "その他",
];

// ==========================================
// 🎢 施設データ生成
// ==========================================
const createMasterData = function () {
  var rawList = [
    ["ソアリン：ファンタスティックフライト", 120],
    ["ヴェネツィアン・ゴンドラ", 40],
    ["ディズニーシー・トランジットスチーマーライン", 15],
    ["ディズニーシー・トランジットスチーマーライン", 15],
    ["ディズニーシー_トランジットスチーマーライン", 15],
    ["フォートレス・エクスプロレーション", 5],
    ["フォートレス・エクスプロレーション”ザ・レオナルドチャレンジ”", 15],
    ["タワー・オブ・テラー", 70],
    ["トイ・ストーリー・マニア！", 100],
    ["タートル・トーク", 35],
    ["ディズニーシー・エレクトリックレールウェイ", 15],
    ["ディズニーシー・エレクトリックレールウェイ", 15],
    ["ビッグシティ・ヴィークル", 15],
    ["ニモ＆フレンズ・シーライダー", 40],
    ["アクアトピア", 20],
    ["インディー・ジョーンズ・アドベンチャー：クリスタルスカルの魔宮", 60],
    ["レイジングスピリッツ", 50],
    ["シンドバッド・ストーリーブック・ヴォヤッジ", 10],
    ["マジックランプシアター", 30],
    ["キャラバンカルーセル", 15],
    ["ジャスミンのフライングカーペット", 15],
    ["フランダーのフライングフィッシュコースター", 25],
    ["スカットルのスクーター", 20],
    ["マーメイドラグーンシアター", 30],
    ["ジャンピン・ジェリーフィッシュ", 15],
    ["ブローフィッシュ・バルーンレース", 20],
    ["ワールプール", 20],
    ["アリエルのプレイグラウンド", 5],
    ["センター・オブ_ジ・アース", 80],
    ["海底2万マイル", 20],
    ["アナとエルサのフローズンジャーニー", 120],
    ["ラプンツェルのランタンフェスティバル", 80],
    ["ピーターパンのネバーランドアドベンチャー", 90],
    ["フェアリー・ティンカーベルのビジーバギー", 60],
    ["カフェ・ポルトフィーノ", 45],
    ["ゴンドリエ・スナック", 20],
    ["ザンビーニ・ブラザーズ・リストランテ", 45],
    ["マゼランズ", 60],
    ["マンマ・ビスコッティーズ・ベーカリー", 30],
    ["リストランテ・ディ_カナレット", 60],
    ["リフレスコス", 20],
    ["ポップコーンワゴン（ソアリン前）", 15],
    ["アイスクリームワゴン（救護室前）", 10],
    ["ケープコッド・クックオフ", 45],
    ["ケープコッド・クックオフ(ショー）", 60],
    ["ウォーターサイドテラス", 10],
    ["S.S.コロンビア・ダイニングルーム", 60],
    ["ケープコッド・コンフェクション", 20],
    ["スパークリング・ジュビリーワゴン", 15],
    ["テディ・ルーズヴェルト・ラウンジ", 60],
    ["テディ・ルーズヴェルト・ラウンジ(テラス）", 45],
    ["デランシー・ケータリング", 15],
    ["ドックサイド・ダイナー", 40],
    ["ニューヨーク・デリ", 40],
    ["バーナクル・ビルズ", 20],
    ["ハイタイド・トリート", 20],
    ["ハドソンリバー・ハーベスト", 20],
    ["パパダキス・フレッシュフルーツ", 10],
    ["リバティー・ランディング・ダイナー", 25],
    ["レストラン櫻", 60],
    ["ポップコーンワゴン（ドックサイド前）", 15],
    ["ポップコーンワゴン（クックオフ前）", 15],
    ["ポップコーンワゴン（リドアイル前）", 15],
    ["ポップコーンワゴン（リバティー前）", 15],
    ["アイスクリームワゴン（トイビル横）", 10],
    ["シーサイドスナック", 20],
    ["ブリーズウェイ・バイツ", 20],
    ["ベイサイド・テイクアウト", 20],
    ["ホライズンベイ・レストラン", 45],
    ["アイスクリームワゴン（アクアトピア横）", 10],
    ["ポップコーンワゴン（アクアトピア横）", 15],
    ["エクスペディション・イート", 20],
    ["トロピック・アルズ", 15],
    ["ミゲルズ・エルドラド・キャンティーナ", 40],
    ["ユカタン・ベースキャンプ・グリル", 40],
    ["ユカタン（テイクアウト）", 20],
    ["ロストリバークックハウス", 25],
    ["ポップコーンワゴン（ハンガー横）", 15],
    ["アイスクリームワゴン（インディー横）", 10],
    ["アレンデール・ロイヤルバンケット", 60],
    ["オーケンのオーケーフード", 20],
    ["スナグリーダックリング", 45],
    ["ルックアウト・クックアウト", 40],
    ["ポップコーンワゴン（バギー前）", 20],
    ["アイスクリームワゴン（スプリングス前）", 10],
    ["オープンセサミ", 20],
    ["カスバ・フードコート", 40],
    ["サルタンズ・オアシス", 20],
    ["ポップコーンワゴン（アラビアン前）", 15],
    ["アイスクリームワゴン（アグラバー前）", 10],
    ["セバスチャンのカリプソキッチン", 40],
    ["ポップコーンワゴン（スカットル前）", 15],
    ["ポップコーンワゴン（コーヴ横）", 15],
    ["アイスクリームワゴン（アリエル前）", 10],
    ["ヴォルケイニア・レストラン", 45],
    ["ノーチラスギャレー", 20],
    ["リフレッシュメント・ステーション", 30],
    ["アイスクリームワゴン（ノーチラス横）", 10],
    ["スパークリング・ジュビリー・セレブレーション", 30],
    ["スパークリング・ジュビリー・ナイト", 30],
    ["ビリーヴ！～シー・オブ・ドリームス～", 60],
    ["ダッフィー＆フレンズのワンダフル・フレンドシップ", 60],
    ["ダンス・ザ・グローブ！", 30],
    ["ドリームス・テイク・フライト", 30],
    ["スカイ・フル・オブ・カラーズ", 15],
    ["ヴィレッジ・グリーティングスペース", 60],
    ["”サル―ドス・アミーゴス！”グリーティングドック", 45],
    ["ミッキー＆フレンズ（ミッキー）", 60],
    ["ミッキー＆フレンズ（ミニー）", 45],
    ["ミッキー＆フレンズ（ドナルド）", 45],
    ["ディズニーシー・プラザ（グリーティング）", 45],
    ["イル・ポスティーノ・ステーショナリー", 5],
    ["ヴァレンティ―ナズ・スウィート", 10],
    ["ヴィラ・ドナルド・ホームショップ", 5],
    ["ヴェネツィアン・カーニバル・マーケット", 5],
    ["エンポーリオ", 15],
    ["ガッレリーア・ディズニー", 15],
    ["スプレンディード", 5],
    ["ピッコロメルカート", 5],
    ["フィガロズ・クロージアー", 5],
    ["フォトグラフィカ", 10],
    ["ベッラ・ミンニ・コレクション", 5],
    ["マーチャント・オブ・ヴェニス・コレクション", 5],
    ["ミラマーレ", 5],
    ["リメンブランツェ", 5],
    ["アーント・ペグズ・ヴィレッジストア", 15],
    ["スチームボート・ミッキーズ", 5],
    ["スリンキー・ドッグのギフトトロリー", 5],
    ["タワー・オブ・テラー・メモラビリア", 5],
    ["タワー・オブ_テラー・カプセルトイ", 20],
    ["ニュージーズ・ノヴェルティ", 5],
    ["マクダックス・デパートメントストア", 15],
    ["スカイウォッチャー・スーヴェニア", 5],
    ["ディスカバリーギフト", 5],
    ["ルックアウト・トレーダー", 5],
    ["ロストリバー・アウトフィッター", 5],
    ["スプリングス・トレジャー", 5],
    ["ファンタジースプリングス・ギフト", 15],
    ["アグラバーマーケットプレイス", 5],
    ["アグラバーマーケットプレイス（ガラス製品）", 15],
    ["アブーズ・バザール", 40],
    ["キス・デ・ガール・ファッション", 5],
    ["コーヴ・オブ・ワンダー", 5],
    ["スリーピーホエール・ショップ", 5],
    ["スリーピーホエール（切り絵）", 20],
    ["スリーピーホエール（似顔絵）", 30],
    ["マーメイドトレジャー", 5],
    ["マーメイドトレジャー（カプセルトイ）", 20],
    ["ノーチラスギフト", 5],
    ["パークウェイギフト・ノース", 5],
    ["パークウェイギフト・サウス", 5],
  ];

  var getCat = function (n: string) {
    var parades = [
      "スパークリング・ジュビリー・セレブレーション",
      "スパークリング・ジュビリー・ナイト",
      "ビリーヴ！～シー・オブ・ドリームス～",
      "ダッフィー＆フレンズのワンダフル・フレンドシップ",
      "ダンス・ザ・グローブ！",
      "ドリームス・テイク・フライト",
      "スカイ・フル・オブ・カラーズ",
    ];
    if (parades.indexOf(n) > -1) return "パレード・ショー";
    if (n.indexOf("グリーティング") > -1 || n.indexOf("サル―ドス") > -1)
      return "グリーティング";
    if (
      n.indexOf("ワゴン") > -1 ||
      n.indexOf("レストラン") > -1 ||
      n.indexOf("カフェ") > -1 ||
      n.indexOf("スナック") > -1 ||
      n.indexOf("リストランテ") > -1 ||
      n.indexOf("ベーカリー") > -1 ||
      n.indexOf("クックオフ") > -1 ||
      n.indexOf("テラス") > -1 ||
      n.indexOf("ダイニング") > -1 ||
      n.indexOf("コンフェクション") > -1 ||
      n.indexOf("ラウンジ") > -1 ||
      n.indexOf("ケータリング") > -1 ||
      n.indexOf("ダイナー") > -1 ||
      n.indexOf("デリ") > -1 ||
      n.indexOf("ビルズ") > -1 ||
      n.indexOf("トリート") > -1 ||
      n.indexOf("ハーベスト") > -1 ||
      n.indexOf("フルーツ") > -1 ||
      n.indexOf("バイツ") > -1 ||
      n.indexOf("テイクアウト") > -1 ||
      n.indexOf("イート") > -1 ||
      n.indexOf("キャンティーナ") > -1 ||
      n.indexOf("グリル") > -1 ||
      n.indexOf("クックハウス") > -1 ||
      n.indexOf("バンケット") > -1 ||
      n.indexOf("フード") > -1 ||
      n.indexOf("ダックリング") > -1 ||
      n.indexOf("クックアウト") > -1 ||
      n.indexOf("セサミ") > -1 ||
      n.indexOf("オアシス") > -1 ||
      n.indexOf("キッチン") > -1 ||
      n.indexOf("ギャレー") > -1 ||
      n.indexOf("ステーション") > -1 ||
      n.indexOf("櫻") > -1 ||
      n.indexOf("アルズ") > -1 ||
      n.indexOf("マゼランズ") > -1
    )
      return "フード";
    if (
      n.indexOf("ショップ") > -1 ||
      n.indexOf("ストア") > -1 ||
      n.indexOf("ギフト") > -1 ||
      n.indexOf("エンポーリオ") > -1 ||
      n.indexOf("スウィート") > -1 ||
      n.indexOf("マーケット") > -1 ||
      n.indexOf("ステーショナリー") > -1 ||
      n.indexOf("クロージアー") > -1 ||
      n.indexOf("フォトグラフィカ") > -1 ||
      n.indexOf("コレクション") > -1 ||
      n.indexOf("ミラマーレ") > -1 ||
      n.indexOf("リメンブランツェ") > -1 ||
      n.indexOf("ミッキーズ") > -1 ||
      n.indexOf("トロリー") > -1 ||
      n.indexOf("メモラビリア") > -1 ||
      n.indexOf("ノヴェルティ") > -1 ||
      n.indexOf("スーヴェニア") > -1 ||
      n.indexOf("トレーダー") > -1 ||
      n.indexOf("アウトフィッター") > -1 ||
      n.indexOf("トレジャー") > -1 ||
      n.indexOf("プレイス") > -1 ||
      n.indexOf("バザール") > -1 ||
      n.indexOf("ファッション") > -1 ||
      n.indexOf("ワンダー") > -1 ||
      n.indexOf("ガッレリーア") > -1 ||
      n.indexOf("スプレンディード") > -1 ||
      n.indexOf("メルカート") > -1
    )
      return "ショップ";
    if (
      n.indexOf("シアター") > -1 ||
      n.indexOf("ビッグバンドビート") > -1 ||
      n.indexOf("タートル・トーク") > -1
    )
      return "シアター";
    return "アトラクション";
  };

  var getSubCat = function (n: string, cat: string) {
    if (cat === "フード") {
      if (
        n.indexOf("ワゴン") > -1 ||
        n.indexOf("ポップコーン") > -1 ||
        n.indexOf("アイスクリーム") > -1
      )
        return "ワゴン";
      if (
        n.indexOf("スナック") > -1 ||
        n.indexOf("キャンティーナ") > -1 ||
        n.indexOf("デリ") > -1 ||
        n.indexOf("ダイナー") > -1 ||
        n.indexOf("オアシス") > -1 ||
        n.indexOf("クックハウス") > -1
      )
        return "クイックサービス";
      return "レストラン";
    }
    if (cat === "アトラクション") {
      if (
        n.indexOf("トランジットスチーマーライン") > -1 ||
        n.indexOf("エレクトリックレールウェイ") > -1 ||
        n.indexOf("ヴィークル") > -1
      )
        return "移動";
      if (n.indexOf("フォートレス") > -1 || n.indexOf("プレイグラウンド") > -1)
        return "体験";
      return "ライド";
    }
    if (cat === "ショップ") {
      if (n.indexOf("カプセルトイ") > -1) return "カプセルトイ";
      return "ショップ";
    }
    return cat;
  };

  var getArea = function (n: string) {
    if (n.indexOf("パークウェイギフト") > -1 || n.indexOf("プラザ") > -1)
      return "その他";
    if (
      n.indexOf("ソアリン") > -1 ||
      n.indexOf("ゴンドラ") > -1 ||
      n.indexOf("フォートレス") > -1 ||
      n.indexOf("ザンビーニ") > -1 ||
      n.indexOf("ポルトフィーノ") > -1 ||
      n.indexOf("マゼランズ") > -1 ||
      n.indexOf("カナレット") > -1 ||
      n.indexOf("ビスコッティ") > -1 ||
      n.indexOf("エンポーリオ") > -1 ||
      n.indexOf("イル・ポスティーノ") > -1
    )
      return "メディテレーニアンハーバー";
    if (
      n.indexOf("トイ・ストーリー") > -1 ||
      n.indexOf("タワー・オブ・テラー") > -1 ||
      n.indexOf("タートル・トーク") > -1 ||
      n.indexOf("ビッグバンド") > -1 ||
      n.indexOf("コロンビア") > -1 ||
      n.indexOf("ルーズヴェルト") > -1 ||
      n.indexOf("櫻") > -1 ||
      n.indexOf("デリ") > -1 ||
      n.indexOf("マクダックス") > -1 ||
      n.indexOf("ケープコッド") > -1 ||
      n.indexOf("ドックサイド") > -1
    )
      return "アメリカンウォーターフロント";
    if (
      n.indexOf("ニモ") > -1 ||
      n.indexOf("アクアトピア") > -1 ||
      n.indexOf("ホライズンベイ") > -1 ||
      n.indexOf("シーサイドスナック") > -1 ||
      n.indexOf("ディスカバリー") > -1
    )
      return "ポートディスカバリー";
    if (
      n.indexOf("インディー") > -1 ||
      n.indexOf("レイジング") > -1 ||
      n.indexOf("ミゲルズ") > -1 ||
      n.indexOf("ユカタン") > -1 ||
      n.indexOf("ロストリバー") > -1
    )
      return "ロストリバーデルタ";
    if (
      n.indexOf("シンドバッド") > -1 ||
      n.indexOf("マジックランプ") > -1 ||
      n.indexOf("キャラバン") > -1 ||
      n.indexOf("ジャスミン") > -1 ||
      n.indexOf("カスバ") > -1 ||
      n.indexOf("サルタンズ") > -1 ||
      n.indexOf("アグラバー") > -1 ||
      n.indexOf("アブーズ") > -1
    )
      return "アラビアンコースト";
    if (
      n.indexOf("マーメイド") > -1 ||
      n.indexOf("フランダー") > -1 ||
      n.indexOf("スカットル") > -1 ||
      n.indexOf("ジャンピン") > -1 ||
      n.indexOf("ブローフィッシュ") > -1 ||
      n.indexOf("ワールプール") > -1 ||
      n.indexOf("アリエル") > -1 ||
      n.indexOf("セバスチャン") > -1 ||
      n.indexOf("スリーピーホエール") > -1 ||
      n.indexOf("キス・デ_ガール") > -1
    )
      return "マーメイドラグーン";
    if (
      n.indexOf("センター") > -1 ||
      n.indexOf("海底2万マイル") > -1 ||
      n.indexOf("ヴォルケイニア") > -1 ||
      n.indexOf("ノーチラス") > -1 ||
      n.indexOf("リフレッシュメント") > -1
    )
      return "ミステリアスアイランド";
    if (
      n.indexOf("フローズン") > -1 ||
      n.indexOf("ラプンツェル") > -1 ||
      n.indexOf("ピーターパン") > -1 ||
      n.indexOf("ティンカーベル") > -1 ||
      n.indexOf("アレンデール") > -1 ||
      n.indexOf("スナグリー") > -1 ||
      n.indexOf("ルックアウト") > -1 ||
      n.indexOf("スプリングス") > -1 ||
      n.indexOf("オーケン") > -1
    )
      return "ファンタジースプリングス";
    if (n.indexOf("ビリーヴ") > -1 || n.indexOf("カラーズ") > -1)
      return "パークワイド";
    return "メディテレーニアンハーバー";
  };

  var getDpaPrice = function (n: string) {
    if (n.indexOf("ビリーヴ") > -1) return 2500;
    if (
      n.indexOf("ソアリン") > -1 ||
      n.indexOf("トイ・ストーリー") > -1 ||
      n.indexOf("フローズン") > -1 ||
      n.indexOf("ピーターパン") > -1 ||
      n.indexOf("ラプンツェル") > -1
    )
      return 2000;
    if (
      n.indexOf("タワー・オブ・テラー") > -1 ||
      n.indexOf("センター") > -1 ||
      n.indexOf("インディー") > -1 ||
      n.indexOf("レイジング") > -1
    )
      return 1500;
    return 0;
  };

  var getPasses = function (n: string) {
    var isPp = false;
    var isSp = false;
    if (
      n.indexOf("ニモ") > -1 ||
      n.indexOf("タートル・トーク") > -1 ||
      n.indexOf("インディー") > -1 ||
      n.indexOf("レイジング") > -1 ||
      n.indexOf("マジックランプ") > -1 ||
      n.indexOf("海底2万マイル") > -1 ||
      n.indexOf("アクアトピア") > -1
    )
      isPp = true;
    if (
      n.indexOf("フローズン") > -1 ||
      n.indexOf("ラプンツェル") > -1 ||
      n.indexOf("ピーターパン") > -1 ||
      n.indexOf("ティンカーベル") > -1
    )
      isSp = true;
    return { pp: isPp, sp: isSp };
  };

  var getBudget = function (n: string, cat: string) {
    if (cat !== "フード") return "-";
    var expensive = [
      "マゼランズ",
      "S.S.コロンビア",
      "カナレット",
      "櫻",
      "ホライズンベイ",
      "ルーズヴェルト",
      "アレンデール",
    ];
    for (var i = 0; i < expensive.length; i++) {
      if (n.indexOf(expensive[i]) > -1) return "$$$";
    }
    if (
      n.indexOf("ワゴン") > -1 ||
      n.indexOf("ポップコーン") > -1 ||
      n.indexOf("アイスクリーム") > -1 ||
      n.indexOf("スナック") > -1 ||
      n.indexOf("オープンセサミ") > -1 ||
      n.indexOf("パパダキス") > -1 ||
      n.indexOf("リフレスコス") > -1 ||
      n.indexOf("ブリーズウェイ") > -1 ||
      n.indexOf("ノーチラスギャレー") > -1 ||
      n.indexOf("エクスペディション・イート") > -1
    ) {
      return "$";
    }
    return "$$";
  };

  var data = [];
  var closedList = [
    "シンドバッド・ストーリーブック・ヴォヤッジ",
    "マーメイドラグーンシアター",
  ];

  for (var i = 0; i < rawList.length; i++) {
    var name = rawList[i][0] as string;
    var wait = rawList[i][1] as number;
    var cat = getCat(name);
    var subCat = getSubCat(name, cat);
    var area = getArea(name);
    var dpaCost = getDpaPrice(name);
    var passes = getPasses(name);

    var h = 0;
    if (
      name.indexOf("タワー・オブ・テラー") > -1 ||
      name.indexOf("センター") > -1 ||
      name.indexOf("ピーターパン") > -1
    )
      h = 102;
    if (name.indexOf("インディー") > -1 || name.indexOf("レイジング") > -1)
      h = 117;
    if (name.indexOf("ニモ") > -1 || name.indexOf("フランダー") > -1) h = 90;

    data.push({
      id: i + 1,
      name: name,
      area: area,
      category: cat,
      subCategory: subCat,
      baseWait: wait,
      dpa: dpaCost > 0,
      dpaPrice: dpaCost,
      pp: passes.pp,
      sp: passes.sp,
      mobileOrder:
        cat === "フード" &&
        name.indexOf("ワゴン") === -1 &&
        name.indexOf("アイスクリーム") === -1,
      indoor: i % 2 === 0,
      height: h,
      budget: getBudget(name, cat),
      isClosed: closedList.indexOf(name) > -1,
    });
  }
  return data;
};

const MASTER_DATA = createMasterData();

export default function App() {
  const [tab, setTab] = useState("main");
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [favorites, setFavorites] = useState<number[]>([]);
  const [manualWaits, setManualWaits] = useState<Record<number, number>>({});

  const [search, setSearch] = useState("");
  const [fCat, setFCat] = useState("すべて");
  const [fArea, setFArea] = useState("すべて");
  const [fDpa, setFDpa] = useState(false);
  const [fMo, setFMo] = useState(false);
  const [fFav, setFFav] = useState(false);

  const [settings, setSettings] = useState({
    weather: "晴",
    time: "昼",
    fatigue: 1,
    hunger: 1,
    who: "ガッツリ(学生など)",
    height: 117,
    budget: "気にしない",
    currentArea: "すべて",
    moodArea: "すべて",
    emergencyFood: false,
    souvenirMode: false,
    showClosed: false,
    pins: [0, 0, 0],
  });

  const updateSettings = function (updates: any) {
    setSettings(function (prev) {
      return Object.assign({}, prev, updates);
    });
  };

  const scoredData = useMemo(
    function () {
      var coeff: any = { 朝: 0.8, 昼: 1.4, 夜: 0.6 };
      var timeCoeff = coeff[settings.time] || 1.0;

      return MASTER_DATA.map(function (item) {
        var reasons: string[] = [];
        var expectedWait = Math.round(item.baseWait * timeCoeff);
        var wait =
          manualWaits[item.id] !== undefined
            ? manualWaits[item.id]
            : expectedWait;

        if (item.isClosed) {
          return Object.assign({}, item, {
            currentWait: "休止",
            score: -999999,
            reasons: ["❌ 現在は休止中です"],
          });
        }

        var scoreA = item.baseWait * 2;
        var scoreB = Math.max(0, 120 - wait);
        var dealDiff = expectedWait - wait;
        var scoreC =
          dealDiff > 30 && item.category !== "パレード・ショー"
            ? dealDiff * 3
            : 0;
        if (scoreC > 0) reasons.push("🔥 今が超狙い目！バグレベルで空いてます");
        if (item.category === "パレード・ショー")
          reasons.push("🎪 必見のエンターテイメント！");

        var scoreD = 0;
        if (
          settings.fatigue >= 4 &&
          (item.category === "シアター" ||
            item.category === "パレード・ショー" ||
            item.category === "フード" ||
            item.indoor)
        ) {
          scoreD += settings.fatigue * 20;
          reasons.push("☕ 疲労回復：座って休めるスポットです");
        }
        if (settings.hunger >= 2 && item.category === "フード") {
          scoreD += settings.hunger * 30;
          reasons.push("🍴 空腹解消：美味しい食事をどうぞ");
        }
        if (settings.weather === "雨" && item.indoor) {
          scoreD += 50;
          reasons.push("☔ 雨の日でも安心の屋内施設");
        }

        if (settings.who === "ガッツリ(学生など)") {
          if (item.height > 0 || item.dpa) {
            scoreD += 50;
            reasons.push("🎢 ガッツリ派におすすめ！");
          }
        } else {
          if (
            item.height === 0 &&
            (item.category === "アトラクション" ||
              item.category === "シアター" ||
              item.category === "グリーティング")
          ) {
            scoreD += 50;
            reasons.push("👶 ゆったり楽しめます");
          }
          if (item.height > 0) scoreD -= 30;
        }

        var scoreE = 0;
        if (
          settings.currentArea !== "すべて" &&
          item.area === settings.currentArea
        ) {
          scoreE += 30;
          reasons.push("📍 現在地に近いです！");
        }
        if (settings.moodArea !== "すべて" && item.area === settings.moodArea) {
          scoreE += 50;
          reasons.push("🎵 今の気分にあってます！");
        }

        if (item.pp)
          reasons.push("🎫 プライオリティパスが取れる可能性があります");
        if (item.sp) reasons.push("🎟️ スタンバイパスが取れる可能性があります");

        if (settings.emergencyFood && item.category === "フード") {
          scoreE += 10000;
          reasons.push("🚨 緊急食事：モバイルオーダー推奨");
        }
        if (settings.souvenirMode && item.category === "ショップ") {
          scoreE += 10000;
          reasons.push("🎁 お土産：空いている今のうちに");
        }
        if (item.id === settings.pins[0]) {
          scoreE += 100000;
          reasons.push("👑 第1希望！最優先案内");
        } else if (item.id === settings.pins[1]) {
          scoreE += 50000;
          reasons.push("🥈 第2希望！おすすめ");
        } else if (item.id === settings.pins[2]) {
          scoreE += 30000;
          reasons.push("🥉 第3希望！チャンスあり");
        }

        var penalty = 0;
        if (item.height > settings.height) {
          penalty += 200000;
          reasons.push("⚠️ お子様の身長が制限に満たない可能性があります");
        }

        // 🚨 予算オーバー判定（ペナルティ追加）
        if (
          settings.budget !== "気にしない" &&
          item.category === "フード" &&
          item.budget !== "-"
        ) {
          if (item.budget.length > settings.budget.length) {
            // 緊急食事モードの加点を完全に沈める特大ペナルティ
            penalty += 200000;
            reasons.push("💸 予算オーバーです");
          }
        }

        return Object.assign({}, item, {
          currentWait: wait,
          score: scoreA + scoreB + scoreC + scoreD + scoreE - penalty,
          reasons: reasons,
        });
      });
    },
    [settings, manualWaits]
  );

  const filteredData = useMemo(
    function () {
      var result = [];
      for (var i = 0; i < scoredData.length; i++) {
        var item = scoredData[i];
        var isOk = true;
        if (item.isClosed && !settings.showClosed) isOk = false;
        if (search !== "" && item.name.indexOf(search) === -1) isOk = false;
        if (fCat !== "すべて" && item.category !== fCat) isOk = false;
        if (fArea !== "すべて" && item.area !== fArea) isOk = false;
        if (fDpa && !item.dpa) isOk = false;
        if (fMo && !item.mobileOrder) isOk = false;
        if (fFav && favorites.indexOf(item.id) === -1) isOk = false;
        if (isOk) result.push(item);
      }
      return result;
    },
    [
      scoredData,
      search,
      fCat,
      fArea,
      fDpa,
      fMo,
      fFav,
      favorites,
      settings.showClosed,
    ]
  );

  const toggleFav = function (id: number, e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    setFavorites(function (prev) {
      return prev.indexOf(id) !== -1
        ? prev.filter(function (fid) {
            return fid !== id;
          })
        : prev.concat([id]);
    });
  };

  const selectedItem = useMemo(
    () => scoredData.find((item) => item.id === selectedId),
    [scoredData, selectedId]
  );

  return (
    <div className="bg-[#F8F9FB] min-h-screen max-w-md mx-auto pb-24 font-sans text-gray-800 shadow-2xl relative">
      {/* 🟦 ヘッダー */}
      <header
        className={
          "px-6 py-6 sticky top-0 z-40 transition-colors shadow-md " +
          (settings.emergencyFood
            ? "bg-red-600"
            : settings.souvenirMode
            ? "bg-yellow-500"
            : "bg-[#0091D0]")
        }
      >
        <div className="flex justify-between items-end">
          <h1 className="text-3xl font-black tracking-tighter text-white drop-shadow-sm">
            TDR Concierge
          </h1>
          <div className="text-[10px] font-bold text-white bg-black/20 px-3 py-1 rounded-full">
            {settings.time} / {settings.weather}
          </div>
        </div>
      </header>

      <main className="p-4 space-y-6">
        {/* --- メインタブ --- */}
        {tab === "main" && (
          <div className="space-y-4">
            <div className="px-2 text-xs font-bold text-[#D4AF37] leading-relaxed">
              🔍詳細画面を確認したり、フィルター機能から絞り込みをかけたりして情報を得ましょう！詳細画面から現在の待ち時間を入力してみましょう！
            </div>
            <div className="space-y-3 sticky top-[84px] z-30 bg-[#F8F9FB] pt-2 pb-2">
              <input
                className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 px-4 shadow-sm text-sm font-bold outline-none focus:border-[#0091D0]"
                placeholder="施設名で検索..."
                value={search}
                onChange={function (e) {
                  setSearch(e.target.value);
                }}
              />
              <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
                <button
                  onClick={function () {
                    setFFav(!fFav);
                  }}
                  className={
                    "px-3 py-2 rounded-xl text-[10px] font-bold shrink-0 border transition-colors " +
                    (fFav
                      ? "bg-[#0091D0] border-[#0091D0] text-white"
                      : "bg-white border-gray-200 text-gray-500")
                  }
                >
                  ♥ お気に入り
                </button>
                <select
                  value={fCat}
                  onChange={function (e) {
                    setFCat(e.target.value);
                  }}
                  className="bg-white border border-gray-200 px-3 py-2 rounded-xl text-[10px] font-bold shrink-0 outline-none"
                >
                  <option value="すべて">全カテゴリ</option>
                  {[
                    "アトラクション",
                    "パレード・ショー",
                    "フード",
                    "ショップ",
                    "シアター",
                    "グリーティング",
                  ].map(function (c) {
                    return (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    );
                  })}
                </select>
                <select
                  value={fArea}
                  onChange={function (e) {
                    setFArea(e.target.value);
                  }}
                  className="bg-white border border-gray-200 px-3 py-2 rounded-xl text-[10px] font-bold shrink-0 outline-none"
                >
                  <option value="すべて">全エリア</option>
                  {AREAS.map(function (a) {
                    return (
                      <option key={a} value={a}>
                        {a}
                      </option>
                    );
                  })}
                </select>
                <button
                  onClick={function () {
                    setFDpa(!fDpa);
                  }}
                  className={
                    "px-3 py-2 rounded-xl text-[10px] font-bold shrink-0 border transition-colors " +
                    (fDpa
                      ? "bg-[#0091D0] border-[#0091D0] text-white"
                      : "bg-white border-gray-200 text-gray-500")
                  }
                >
                  DPA
                </button>
                <button
                  onClick={function () {
                    setFMo(!fMo);
                  }}
                  className={
                    "px-3 py-2 rounded-xl text-[10px] font-bold shrink-0 border transition-colors " +
                    (fMo
                      ? "bg-[#0091D0] border-[#0091D0] text-white"
                      : "bg-white border-gray-200 text-gray-500")
                  }
                >
                  MO
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-3">
              {filteredData.slice(0, 50).map(function (item) {
                var isFav = favorites.indexOf(item.id) !== -1;
                return (
                  <div
                    key={item.id}
                    onClick={function () {
                      setSelectedId(item.id);
                    }}
                    className={
                      "p-5 rounded-[24px] border shadow-sm flex items-center justify-between cursor-pointer active:scale-[0.98] transition-transform " +
                      (item.isClosed
                        ? "bg-gray-100 border-gray-200 opacity-60"
                        : "bg-white border-gray-100")
                    }
                  >
                    <div className="flex-1 pr-4">
                      <div className="flex items-center flex-wrap gap-1.5 mb-1">
                        <span className="text-[9px] font-bold text-[#0091D0] uppercase mr-1">
                          {item.category}
                        </span>
                        {item.height > 0 && (
                          <span className="bg-orange-50 text-orange-600 border border-orange-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                            {item.height}cm~
                          </span>
                        )}
                        {item.dpa && (
                          <span className="bg-[#FDF8E7] text-[#D4AF37] border border-[#F0DF9B] text-[8px] font-bold px-1.5 py-0.5 rounded">
                            DPA
                          </span>
                        )}
                        {item.pp && (
                          <span className="bg-green-50 text-green-600 border border-green-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                            PP
                          </span>
                        )}
                        {item.sp && (
                          <span className="bg-purple-50 text-purple-600 border border-purple-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                            SP
                          </span>
                        )}
                        {item.mobileOrder && (
                          <span className="bg-blue-50 text-blue-600 border border-blue-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                            MO
                          </span>
                        )}
                      </div>
                      <h3 className="text-sm font-bold leading-tight text-gray-800">
                        {item.name}
                      </h3>
                    </div>
                    <div className="text-right flex flex-col items-end">
                      <div className="text-2xl font-black text-gray-800 leading-none">
                        {item.category === "パレード・ショー" && !item.isClosed
                          ? "公演"
                          : item.currentWait}
                        <span className="text-[10px] font-bold text-gray-400 ml-0.5">
                          {item.isClosed || item.category === "パレード・ショー"
                            ? ""
                            : "m"}
                        </span>
                      </div>
                      <button
                        onClick={function (e) {
                          toggleFav(item.id, e);
                        }}
                        className={
                          "mt-2 text-2xl " +
                          (isFav ? "text-red-500" : "text-gray-200")
                        }
                      >
                        {isFav ? "♥" : "♡"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* --- ランキングタブ --- */}
        {tab === "ranking" && (
          <div className="space-y-4">
            <div className="px-2 text-xs font-bold text-[#D4AF37] leading-relaxed">
              👑あなたへのおすすめをランキングにしました！確認してみましょう！
              <br />
              ⏱️
              メイン画面や下のリストから待ち時間を常に更新して、今行くべき「お得な」アトラクションを見つけましょう！
            </div>
            {scoredData
              .filter(function (i) {
                return !i.isClosed || settings.showClosed;
              })
              .sort(function (a, b) {
                return b.score - a.score;
              })
              .slice(0, 20)
              .map(function (item, i) {
                var isFav = favorites.indexOf(item.id) !== -1;
                return (
                  <div
                    key={item.id}
                    onClick={function () {
                      setSelectedId(item.id);
                    }}
                    className={
                      "p-5 rounded-[24px] border flex items-center gap-4 cursor-pointer " +
                      (item.isClosed
                        ? "bg-gray-100 opacity-60"
                        : i < 3
                        ? "bg-[#0091D0] text-white border-transparent shadow-md"
                        : "bg-white border-gray-100")
                    }
                  >
                    <span
                      className={
                        "text-2xl font-black italic w-6 text-center " +
                        (i < 3 ? "text-[#D4AF37]" : "text-gray-300")
                      }
                    >
                      {i + 1}
                    </span>
                    <div className="flex-1">
                      <div
                        className={
                          "text-[9px] font-bold mb-0.5 " +
                          (i < 3 ? "text-blue-100" : "text-[#0091D0]")
                        }
                      >
                        {item.area}
                      </div>
                      <div className="text-sm font-bold leading-tight">
                        {item.name}
                      </div>
                    </div>
                    <div className="text-right flex flex-col items-end">
                      <div className="text-xl font-black">
                        {item.category === "パレード・ショー" && !item.isClosed
                          ? "公演"
                          : item.currentWait}
                      </div>
                      {isFav && (
                        <div className="text-red-500 text-xs mt-1">♥</div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        )}

        {/* --- ダッシュボード(設定)タブ --- */}
        {tab === "dashboard" && (
          <div className="space-y-6 pt-2">
            <div className="px-2 text-xs font-bold text-[#D4AF37] leading-relaxed">
              ✨
              お好みに合わせて設定してください。あなたの「今の気分」にぴったりのお得なプランを提案します。
            </div>

            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={function () {
                  updateSettings({ emergencyFood: !settings.emergencyFood });
                }}
                className={
                  "p-6 rounded-[24px] flex flex-col items-center gap-2 border-2 transition-colors " +
                  (settings.emergencyFood
                    ? "bg-red-50 border-red-500 text-red-600"
                    : "bg-white border-gray-100 text-gray-400")
                }
              >
                <span className="text-3xl">🍔</span>
                <span className="text-[10px] font-bold">緊急食事モード</span>
              </button>
              <button
                onClick={function () {
                  updateSettings({ souvenirMode: !settings.souvenirMode });
                }}
                className={
                  "p-6 rounded-[24px] flex flex-col items-center gap-2 border-2 transition-colors " +
                  (settings.souvenirMode
                    ? "bg-[#FDF8E7] border-[#D4AF37] text-[#D4AF37]"
                    : "bg-white border-gray-100 text-gray-400")
                }
              >
                <span className="text-3xl">🎁</span>
                <span className="text-[10px] font-bold">お土産モード</span>
              </button>
            </div>

            <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">
                    今いるエリア
                  </label>
                  <select
                    value={settings.currentArea}
                    onChange={function (e) {
                      updateSettings({ currentArea: e.target.value });
                    }}
                    className="w-full bg-gray-50 p-3 rounded-xl text-xs font-bold border-none outline-none"
                  >
                    <option value="すべて">指定なし</option>
                    {AREAS.map(function (a) {
                      return (
                        <option key={a} value={a}>
                          {a}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">
                    今の気分
                  </label>
                  <select
                    value={settings.moodArea}
                    onChange={function (e) {
                      updateSettings({ moodArea: e.target.value });
                    }}
                    className="w-full bg-gray-50 p-3 rounded-xl text-xs font-bold border-none outline-none"
                  >
                    <option value="すべて">指定なし</option>
                    {AREAS.map(function (a) {
                      return (
                        <option key={a} value={a}>
                          {a}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm space-y-6">
              <div className="space-y-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                  疲労度 (1=元気, 5=限界)
                </label>
                <input
                  type="range"
                  min="1"
                  max="5"
                  value={settings.fatigue}
                  onChange={function (e) {
                    updateSettings({ fatigue: Number(e.target.value) });
                  }}
                  className="w-full accent-[#0091D0]"
                />
                <div className="flex justify-between px-1">
                  {[1, 2, 3, 4, 5].map(function (n) {
                    return (
                      <span
                        key={n}
                        className={
                          "text-[10px] font-bold " +
                          (settings.fatigue === n
                            ? "text-[#0091D0]"
                            : "text-gray-300")
                        }
                      >
                        {n}
                      </span>
                    );
                  })}
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                  空腹度 (1=満足, 3=空腹)
                </label>
                <input
                  type="range"
                  min="1"
                  max="3"
                  value={settings.hunger}
                  onChange={function (e) {
                    updateSettings({ hunger: Number(e.target.value) });
                  }}
                  className="w-full accent-[#0091D0]"
                />
                <div className="flex justify-between px-1">
                  {[1, 2, 3].map(function (n) {
                    return (
                      <span
                        key={n}
                        className={
                          "text-[10px] font-bold " +
                          (settings.hunger === n
                            ? "text-[#0091D0]"
                            : "text-gray-300")
                        }
                      >
                        {n}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="space-y-4 bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
              <label className="text-xs font-bold text-gray-800 border-l-4 border-[#0091D0] pl-2 block">
                絶対行きたい場所 (ピン留め)
              </label>
              {[1, 2, 3].map(function (num, idx) {
                return (
                  <div key={idx}>
                    <label className="text-[10px] font-bold text-gray-400 mb-1 block">
                      {num}位 {["🥇", "🥈", "🥉"][idx]}
                    </label>
                    <select
                      value={settings.pins[idx]}
                      onChange={function (e) {
                        var newPins = [
                          settings.pins[0],
                          settings.pins[1],
                          settings.pins[2],
                        ];
                        newPins[idx] = Number(e.target.value);
                        updateSettings({ pins: newPins });
                      }}
                      className="w-full bg-gray-50 border border-gray-200 rounded-xl py-3 px-3 text-sm font-bold outline-none"
                    >
                      <option value={0}>ー</option>
                      {MASTER_DATA.filter(function (d) {
                        return !d.isClosed;
                      }).map(function (d) {
                        return (
                          <option key={d.id} value={d.id}>
                            {d.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}
            </div>

            <div className="space-y-5 bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
              <div>
                <label className="text-[10px] font-bold text-gray-400 block mb-2">
                  今の時間帯
                </label>
                <div className="flex gap-2">
                  {["朝", "昼", "夜"].map(function (opt) {
                    return (
                      <button
                        key={opt}
                        onClick={function () {
                          updateSettings({ time: opt });
                        }}
                        className={
                          "w-12 h-12 rounded-full text-sm font-bold border transition-colors flex items-center justify-center " +
                          (settings.time === opt
                            ? "bg-[#e0f2fe] text-[#0091D0] border-[#0091D0]"
                            : "bg-white text-gray-500 border-gray-200")
                        }
                      >
                        {opt}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div>
                <label className="text-[10px] font-bold text-gray-400 block mb-2">
                  どう回る？
                </label>
                <div className="flex gap-2">
                  {["ガッツリ(学生など)", "ゆったり(お子様連れなど)"].map(
                    function (opt) {
                      return (
                        <button
                          key={opt}
                          onClick={function () {
                            updateSettings({ who: opt });
                          }}
                          className={
                            "px-4 py-2.5 rounded-full text-[10px] font-bold border transition-colors " +
                            (settings.who === opt
                              ? "bg-[#e0f2fe] text-[#0091D0] border-[#0091D0]"
                              : "bg-white text-gray-500 border-gray-200")
                          }
                        >
                          {opt}
                        </button>
                      );
                    }
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">
                    天候
                  </label>
                  <select
                    value={settings.weather}
                    onChange={function (e) {
                      updateSettings({ weather: e.target.value });
                    }}
                    className="w-full bg-gray-50 p-3 rounded-xl text-xs font-bold border-none outline-none"
                  >
                    <option>晴</option>
                    <option>雨</option>
                  </select>
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">
                    子供の身長
                  </label>
                  <select
                    value={settings.height}
                    onChange={function (e) {
                      updateSettings({ height: Number(e.target.value) });
                    }}
                    className="w-full bg-gray-50 p-3 rounded-xl text-xs font-bold border-none outline-none"
                  >
                    <option value={80}>81cm未満 (ベビー)</option>
                    <option value={81}>81cm以上</option>
                    <option value={90}>90cm以上</option>
                    <option value={102}>102cm以上</option>
                    <option value={117}>117cm以上 (全施設OK)</option>
                  </select>
                </div>
              </div>

              {/* 🌟 追加：フードの予算設定 */}
              <div>
                <label className="text-[10px] font-bold text-gray-400 block mb-1">
                  フードの予算
                </label>
                <select
                  value={settings.budget}
                  onChange={function (e) {
                    updateSettings({ budget: e.target.value });
                  }}
                  className="w-full bg-gray-50 p-3 rounded-xl text-xs font-bold border-none outline-none"
                >
                  <option value="気にしない">気にしない</option>
                  <option value="$">$ (〜1,000円: 食べ歩き等)</option>
                  <option value="$$">$$ (〜2,000円: セットメニュー等)</option>
                  <option value="$$$">$$$ (3,000円〜: コース・高級)</option>
                </select>
              </div>

              <div className="flex justify-between items-center pt-2">
                <span className="text-xs font-bold text-gray-800">
                  休止中の施設を表示する
                </span>
                <button
                  onClick={function () {
                    updateSettings({ showClosed: !settings.showClosed });
                  }}
                  className={
                    "w-10 h-5 rounded-full relative transition-colors " +
                    (settings.showClosed ? "bg-[#0091D0]" : "bg-gray-200")
                  }
                >
                  <div
                    className={
                      "absolute top-0.5 w-3.5 h-3.5 bg-white rounded-full transition-all " +
                      (settings.showClosed ? "right-0.5" : "left-0.5")
                    }
                  />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* --- お気に入りタブ --- */}
        {tab === "favorites" && (
          <div className="space-y-4">
            <div className="px-2 text-xs font-bold text-[#D4AF37] leading-relaxed">
              💛お気に入りだけを集めていつでも情報をチェックできます！
            </div>

            {favorites.length === 0 ? (
              <div className="text-center py-16 text-gray-400 space-y-3">
                <div className="text-4xl">♡</div>
                <div className="text-sm font-bold leading-relaxed">
                  まだお気に入りがありません。
                  <br />
                  メイン画面から「♡」をタップして
                  <br />
                  マイプランに追加しましょう！
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-3">
                {scoredData
                  .filter(function (item) {
                    return favorites.indexOf(item.id) !== -1;
                  })
                  .map(function (item) {
                    return (
                      <div
                        key={item.id}
                        onClick={function () {
                          setSelectedId(item.id);
                        }}
                        className={
                          "p-5 rounded-[24px] border shadow-sm flex items-center justify-between cursor-pointer active:scale-[0.98] transition-transform " +
                          (item.isClosed
                            ? "bg-gray-100 border-gray-200 opacity-60"
                            : "bg-white border-gray-100")
                        }
                      >
                        <div className="flex-1 pr-4">
                          <div className="flex items-center flex-wrap gap-1.5 mb-1">
                            <span className="text-[9px] font-bold text-[#0091D0] uppercase mr-1">
                              {item.category}
                            </span>
                            {item.height > 0 && (
                              <span className="bg-orange-50 text-orange-600 border border-orange-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                                {item.height}cm~
                              </span>
                            )}
                            {item.dpa && (
                              <span className="bg-[#FDF8E7] text-[#D4AF37] border border-[#F0DF9B] text-[8px] font-bold px-1.5 py-0.5 rounded">
                                DPA
                              </span>
                            )}
                            {item.pp && (
                              <span className="bg-green-50 text-green-600 border border-green-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                                PP
                              </span>
                            )}
                            {item.sp && (
                              <span className="bg-purple-50 text-purple-600 border border-purple-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                                SP
                              </span>
                            )}
                            {item.mobileOrder && (
                              <span className="bg-blue-50 text-blue-600 border border-blue-200 text-[8px] font-bold px-1.5 py-0.5 rounded">
                                MO
                              </span>
                            )}
                          </div>
                          <h3 className="text-sm font-bold leading-tight text-gray-800">
                            {item.name}
                          </h3>
                        </div>
                        <div className="text-right flex flex-col items-end">
                          <div className="text-2xl font-black text-gray-800 leading-none">
                            {item.category === "パレード・ショー" &&
                            !item.isClosed
                              ? "公演"
                              : item.currentWait}
                            <span className="text-[10px] font-bold text-gray-400 ml-0.5">
                              {item.isClosed ||
                              item.category === "パレード・ショー"
                                ? ""
                                : "m"}
                            </span>
                          </div>
                          <button
                            onClick={function (e) {
                              toggleFav(item.id, e);
                            }}
                            className="mt-2 text-2xl text-red-500"
                          >
                            ♥
                          </button>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        )}
      </main>

      {/* 🔵 ナビゲーション */}
      <nav className="fixed bottom-0 w-full max-w-md bg-white border-t border-gray-100 py-3 px-2 flex justify-around items-center z-50">
        <button
          onClick={function () {
            setTab("main");
          }}
          className="flex flex-col items-center gap-1 w-16"
        >
          <svg
            className={
              "w-6 h-6 " + (tab === "main" ? "text-[#0091D0]" : "text-gray-300")
            }
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
          <span
            className={
              "text-[9px] font-bold " +
              (tab === "main" ? "text-[#0091D0]" : "text-gray-400")
            }
          >
            メイン
          </span>
        </button>
        <button
          onClick={function () {
            setTab("ranking");
          }}
          className="flex flex-col items-center gap-1 w-16"
        >
          <svg
            className={
              "w-6 h-6 " +
              (tab === "ranking" ? "text-[#0091D0]" : "text-gray-300")
            }
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            ></path>
          </svg>
          <span
            className={
              "text-[9px] font-bold " +
              (tab === "ranking" ? "text-[#0091D0]" : "text-gray-400")
            }
          >
            ランキング
          </span>
        </button>
        <button
          onClick={function () {
            setTab("dashboard");
          }}
          className="flex flex-col items-center gap-1 w-16"
        >
          <svg
            className={
              "w-6 h-6 " +
              (tab === "dashboard" ? "text-[#0091D0]" : "text-gray-300")
            }
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            ></path>
          </svg>
          <span
            className={
              "text-[9px] font-bold " +
              (tab === "dashboard" ? "text-[#0091D0]" : "text-gray-400")
            }
          >
            設定
          </span>
        </button>
        <button
          onClick={function () {
            setTab("favorites");
          }}
          className="flex flex-col items-center gap-1 w-16"
        >
          <svg
            className={
              "w-6 h-6 " +
              (tab === "favorites" ? "text-red-500" : "text-gray-300")
            }
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            ></path>
          </svg>
          <span
            className={
              "text-[9px] font-bold " +
              (tab === "favorites" ? "text-red-500" : "text-gray-400")
            }
          >
            お気に入り
          </span>
        </button>
      </nav>

      {/* 🔴 詳細モーダル */}
      {selectedId && selectedItem && (
        <div
          className="fixed inset-0 z-[100] bg-black/60 flex items-end"
          onClick={function () {
            setSelectedId(null);
          }}
        >
          <div
            className="bg-white w-full rounded-t-[32px] max-h-[90vh] overflow-y-auto pb-10 shadow-2xl"
            onClick={function (e) {
              e.stopPropagation();
            }}
          >
            <div className="p-6 border-b flex justify-between items-center sticky top-0 bg-white/90 backdrop-blur z-10">
              <button
                onClick={function () {
                  setSelectedId(null);
                }}
                className="text-gray-400 p-2 font-bold text-xs"
              >
                ✕ 閉じる
              </button>
              <button
                onClick={function (e) {
                  toggleFav(selectedItem.id, e);
                }}
                className={
                  "text-2xl drop-shadow-sm " +
                  (favorites.indexOf(selectedItem.id) !== -1
                    ? "text-red-500"
                    : "text-gray-200")
                }
              >
                {favorites.indexOf(selectedItem.id) !== -1 ? "♥" : "♡"}
              </button>
            </div>
            <div className="p-8 space-y-8">
              <div className="text-center space-y-2">
                <div className="text-[10px] font-bold text-[#D4AF37] uppercase tracking-widest">
                  {selectedItem.area}
                </div>
                <h2 className="text-2xl font-black text-gray-800 leading-tight">
                  {selectedItem.name}
                </h2>
              </div>
              <div
                className={
                  "p-6 rounded-[32px] text-center border relative " +
                  (selectedItem.isClosed
                    ? "bg-gray-100 border-gray-200"
                    : "bg-[#F8F9FB] border-gray-100")
                }
              >
                <div
                  className={
                    "text-4xl font-black " +
                    (selectedItem.isClosed ? "text-gray-400" : "text-gray-800")
                  }
                >
                  {selectedItem.category === "パレード・ショー" &&
                  !selectedItem.isClosed
                    ? "公演"
                    : selectedItem.currentWait}
                  {!selectedItem.isClosed &&
                    selectedItem.category !== "パレード・ショー" && (
                      <span className="text-2xl ml-1 text-gray-400">m</span>
                    )}
                </div>
                <div className="text-[10px] font-bold text-gray-400 mt-1 uppercase tracking-[0.2em]">
                  {selectedItem.isClosed
                    ? "Currently Closed"
                    : selectedItem.category === "パレード・ショー"
                    ? "Scheduled Show"
                    : "Estimated Wait Time"}
                </div>
                {!selectedItem.isClosed &&
                  selectedItem.category !== "パレード・ショー" && (
                    <div className="mt-5 flex items-center justify-center gap-2">
                      <span className="text-[10px] font-bold text-[#0091D0] bg-[#e0f2fe] px-2 py-1 rounded">
                        更新
                      </span>
                      <input
                        type="number"
                        className="w-16 border-b-2 border-[#0091D0] bg-transparent text-center font-bold text-gray-800 outline-none"
                        placeholder={selectedItem.currentWait.toString()}
                        onChange={function (e) {
                          var val = parseInt(e.target.value);
                          if (!isNaN(val) && val >= 0) {
                            setManualWaits(function (prev) {
                              return Object.assign({}, prev, {
                                [selectedItem.id]: val,
                              });
                            });
                          }
                        }}
                      />
                      <span className="text-xs font-bold text-gray-500">
                        分
                      </span>
                    </div>
                  )}
              </div>

              {/* 🌟 施設タイプラベル */}
              <div className="flex flex-wrap justify-center gap-2">
                <span className="bg-[#e0f2fe] text-[#0091D0] px-4 py-1.5 rounded-full text-[10px] font-bold">
                  {selectedItem.subCategory}
                </span>
                <span className="bg-gray-100 text-gray-600 px-4 py-1.5 rounded-full text-[10px] font-bold">
                  {selectedItem.indoor ? "屋内施設" : "屋外施設"}
                </span>
                {selectedItem.category === "フード" && (
                  <span className="bg-gray-100 text-gray-600 px-4 py-1.5 rounded-full text-[10px] font-bold">
                    価格帯: {selectedItem.budget}
                  </span>
                )}
              </div>

              <div className="space-y-3">
                {/* 📏 身長制限カード */}
                {selectedItem.height > 0 && (
                  <div className="bg-orange-50 border border-orange-200 p-5 rounded-2xl shadow-sm text-orange-700 flex items-center justify-between">
                    <div>
                      <div className="text-[9px] font-bold opacity-70 uppercase mb-1">
                        Height Restriction
                      </div>
                      <div className="text-lg font-black tracking-wider">
                        身長{selectedItem.height}cm以上
                      </div>
                    </div>
                    <div className="text-3xl drop-shadow-sm">📏</div>
                  </div>
                )}
                {selectedItem.dpa && (
                  <div className="bg-gradient-to-br from-[#D4AF37] to-[#B59125] p-5 rounded-2xl shadow-md text-white flex items-center justify-between">
                    <div>
                      <div className="text-[9px] font-bold opacity-80 uppercase mb-1">
                        Premier Access
                      </div>
                      <div className="text-lg font-black tracking-wider">
                        DPA対象施設
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-[9px] font-bold opacity-80 mb-0.5">
                        料金
                      </div>
                      <div className="text-2xl font-black">
                        ¥{selectedItem.dpaPrice.toLocaleString()}
                      </div>
                    </div>
                  </div>
                )}
                {selectedItem.pp && (
                  <div className="bg-green-50 border border-green-200 p-5 rounded-2xl shadow-sm text-green-700 flex items-center justify-between">
                    <div>
                      <div className="text-[9px] font-bold opacity-70 uppercase mb-1">
                        Priority Pass
                      </div>
                      <div className="text-lg font-black tracking-wider">
                        PP対象施設
                      </div>
                    </div>
                    <div className="text-3xl drop-shadow-sm">🎫</div>
                  </div>
                )}
                {selectedItem.sp && (
                  <div className="bg-purple-50 border border-purple-200 p-5 rounded-2xl shadow-sm text-purple-700 flex items-center justify-between">
                    <div>
                      <div className="text-[9px] font-bold opacity-70 uppercase mb-1">
                        Standby Pass
                      </div>
                      <div className="text-lg font-black tracking-wider">
                        SP対象施設
                      </div>
                    </div>
                    <div className="text-3xl drop-shadow-sm">🎟️</div>
                  </div>
                )}
                {selectedItem.mobileOrder && (
                  <div className="bg-blue-50 border border-blue-200 p-5 rounded-2xl shadow-sm text-blue-700 flex items-center justify-between">
                    <div>
                      <div className="text-[9px] font-bold opacity-70 uppercase mb-1">
                        Mobile Order
                      </div>
                      <div className="text-lg font-black tracking-wider">
                        MO対象
                      </div>
                    </div>
                    <div className="text-3xl drop-shadow-sm">📱</div>
                  </div>
                )}
              </div>

              {selectedItem.reasons.length > 0 && (
                <div className="space-y-2">
                  <h4 className="text-[10px] font-bold text-gray-400 uppercase mb-2">
                    AI Suggestion
                  </h4>
                  {selectedItem.reasons.map(function (r, idx) {
                    var isMatch = r.indexOf("📍") > -1 || r.indexOf("🎵") > -1;
                    var isPass = r.indexOf("🎫") > -1 || r.indexOf("🎟️") > -1;
                    var isWarning =
                      r.indexOf("⚠️") > -1 || r.indexOf("💸") > -1;

                    var colorClass = "bg-[#FDF8E7] text-[#B59125]";
                    if (r.indexOf("超狙い目") !== -1)
                      colorClass = "bg-red-50 text-red-600";
                    else if (isMatch)
                      colorClass = "bg-[#e0f2fe] text-[#0091D0]";
                    else if (isPass) colorClass = "bg-gray-50 text-gray-700";
                    else if (isWarning)
                      colorClass =
                        "bg-orange-50 text-orange-700 border border-orange-200";

                    return (
                      <div
                        key={idx}
                        className={
                          "text-xs font-bold p-4 rounded-xl " + colorClass
                        }
                      >
                        {r.indexOf("✨") === -1 &&
                        !isMatch &&
                        !isPass &&
                        !isWarning &&
                        r.indexOf("💸") === -1
                          ? "✨ "
                          : ""}
                        {r}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
